<template>
  <div class="sy-number">
    <component :is='componentName' ref="thousands" v-on="$listeners" v-bind="{...$props}" v-model.trim="value"></component>
  </div>
</template>

<script>
import emitter from '../../../utils/emitter'
import syInputNumber from './components/number-custom.vue'
import thousandsInput from './components/thousandsInput.vue'
import readNumber from './components/read-number.vue'
import { numberProps } from './index'

export default {
  name: 'number',
  components: {
    syInputNumber,
    thousandsInput,
    readNumber
  },
  model: {
    prop: 'value',
    event: '_change'
  },
  mixins: [emitter],
  props: numberProps,
  computed: {
    componentName () {
      if (this.isPureText) {
        return 'read-number'
      }
      return this.uiType === 2 ? 'sy-input-number' : 'thousands-input'
    }
  },
  watch: {
    value (val) {
      this.$emit('_change', val)
      this.$emit('change', val)
      this.dispatch('ElFormItem', 'el.form.change', [val])
      // parentVm('ElformItem')?.validate('change')
    }
  }
}
</script>
<style scoped lang="scss">
.sy-number {
  ::v-deep .el-input-number--small {
    width: 100%;
    line-height: 36px;
  }
}
</style>
